import { render } from "./UmedidaList.vue?vue&type=template&id=a3825b9a&scoped=true"
import script from "./UmedidaList.vue?vue&type=script&lang=js"
export * from "./UmedidaList.vue?vue&type=script&lang=js"

import "./UmedidaList.vue?vue&type=style&index=0&id=a3825b9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3825b9a"]])

export default __exports__